import { Select } from "@tfg/ui"
import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { getTraceabilityRequestsQueryParams } from "@tfg/types/schemas/traceabilityRequests"

import { useGetTraceabilityRequestsClients } from "~/pages/SupplierPortal/TraceabilityRequests/hooks/useGetTraceabilityRequestsClients"

type Props = {
  filtersValue: getTraceabilityRequestsQueryParams["filters"]
  setFiltersValue: Dispatch<
    SetStateAction<getTraceabilityRequestsQueryParams["filters"]>
  >
}

export const ClientFilter = ({ filtersValue, setFiltersValue }: Props) => {
  const { t } = useTranslation(["traceability"])
  const { data, isLoading } = useGetTraceabilityRequestsClients({
    filters: filtersValue,
  })
  const TYPE_OPTIONS = data?.map((client) => ({
    label: client.name,
    value: client.id,
  }))
  return (
    <Select
      isLoading={isLoading}
      placeholder={t("filters.client")}
      value={filtersValue?.clientId ?? null}
      onChange={(val) =>
        setFiltersValue((prev) => ({ ...prev, clientId: val ?? undefined }))
      }
      data={TYPE_OPTIONS}
      w={180}
      clearable
    />
  )
}
